export default "__VITE_ASSET__772dfb21__"